import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Category {
  id: string;
  name: string;
  color?: string;
}

interface Item {
  id: string;
  name: string;
  description?: string;
  condition?: string;
  purchasePrice?: number;
  purchaseCurrency?: string;
  location?: string;
  imageUrl?: string;
  images?: Array<{ id: string; url: string; isPrimary?: boolean; order?: number }>;
  isFavorite?: boolean;
  isLocked?: boolean;
  createdAt: string;
  categoryId?: string;
  category?: Category;
}

interface ItemsState {
  items: Item[];
  loading: boolean;
  error: string | null;
  total: number;
}

const initialState: ItemsState = {
  items: [],
  loading: false,
  error: null,
  total: 0,
};

const itemsSlice = createSlice({
  name: 'items',
  initialState,
  reducers: {
    setItems: (state, action: PayloadAction<{ items: Item[]; total: number }>) => {
      state.items = action.payload.items;
      state.total = action.payload.total;
      state.loading = false;
    },
    addItem: (state, action: PayloadAction<Item>) => {
      state.items.unshift(action.payload);
      state.total += 1;
    },
    updateItem: (state, action: PayloadAction<Item>) => {
      const index = state.items.findIndex(item => item.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    removeItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.id !== action.payload);
      state.total -= 1;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const { setItems, addItem, updateItem, removeItem, setLoading, setError } = itemsSlice.actions;
export default itemsSlice.reducer;
